import Loading from './loading'
import AnimateLoad from '../animate-load'

export default AnimateLoad(Loading)
